export default __webpack_public_path__ + "static/media/jeep.5c572492.webp";